import React, { ChangeEvent, useEffect, useState } from 'react';

import './Page.css';

import { Opdrachtgever, Role, User, UserOpdrachtgever } from '../common/types';
import { RES_TYPES, useFetch } from '../hooks/useFetch';
import { FaSave, FaTrash } from 'react-icons/fa';
import { roles } from '../common/consts';
import { useNavigate, useParams } from 'react-router-dom';
import { useCrumbOptionsContext } from '../crumbOptionsProvider';

const createEmptyUser = () => {
  return {
    username: '',
    email: '',
    roles: [] as Role[],
    opdrachtgevers: [] as UserOpdrachtgever[],
  } as User;
};

const UserPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { updateSelectedOption } = useCrumbOptionsContext();
  const { data: opdrachtgevers } = useFetch<Opdrachtgever[]>('/api/opdrachtgever', { defaultValue: [] });
  const { data: postData, res: resPost, fetchData: postUser } = useFetch<User>('/api/user', {
    method: 'POST',
    lateFetch: true,
    resType: RES_TYPES.json,
    defaultValue: {} as User,
  });
  const { data: userData, setUrl: setUserUrl } = useFetch<User>('', { defaultValue: {} as User });
  const {
    fetchData: putUser,
    setUrl: setPutUrl,
  } = useFetch('', { method: 'PUT', lateFetch: true, resType: RES_TYPES.empty, defaultValue: undefined });
  const {
    res: resDel,
    fetchData: deleteUser,
    setUrl: setDelUrl,
  } = useFetch('', { method: 'DELETE', lateFetch: true, resType: RES_TYPES.empty, defaultValue: undefined });
  const [user, setUser] = useState<User>(createEmptyUser());

  useEffect(() => {
    if(!id) {
      return;
    }
    
    if (id === 'new') {
      if (userData) {
        setUser(createEmptyUser());
        setUserUrl('');
      }
    } else {
      setUserUrl(`/api/user/${id}`);
    }
  }, [id]);

  useEffect(() => {
    setUser(prevState => ({
      ...prevState,
      ...userData,
    }));
    if (userData) {
      setDelUrl(`/api/user/${userData.id}`);
      setPutUrl(`/api/user/${userData.id}`);
    }
  }, [userData]);

  useEffect(() => {
    if((resDel && resDel.ok)) {
      updateSelectedOption('users', '');
      navigate('/users');
    }
  }, [resDel]);

  useEffect(() => {
    if(resPost && resPost.ok && postData) {
      updateSelectedOption('users', postData.id);
      alert('Gebruiker succesvol aangemaakt met tijdelijk wachtwoord: ' + postData.password);
      navigate('/users');
    }
  }, [resPost, postData]);

  const updateUser = (event: ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    setUser(prevState => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const addUser = () => {
    let property: keyof typeof user;
    for (property in user) {
      if (!user[property] && property !== 'email') {
        alert('Niet alles is correct ingevuld');
        return;
      }
    }
    if (user.opdrachtgevers.length === 0) {
      alert('Er moet minimaal één opdrachtgever worden toegevoegd');
      return;
    }
    if (id !== 'new' && userData && userData.id) {
      putUser(JSON.stringify(user));
    } else {
      postUser(JSON.stringify(user));
    }
  };

  const toggleRole = (name: string) => {
    const previousLength = user.roles.length;
    const newRoles = user.roles.filter(r => r.name !== name);
    if (newRoles.length === previousLength) {
      newRoles.push({
        name: name,
      });
    }
    setUser(prevState => ({
      ...prevState,
      roles: newRoles,
    }));
  };

  const toggleOpdrachtgever = (id: string) => {
    const previousLength = user.opdrachtgevers.length;
    const newOpdrachtgevers = user.opdrachtgevers.filter(og => og.opdrachtgever_id !== id);
    if (newOpdrachtgevers.length === previousLength) {
      newOpdrachtgevers.push({
        opdrachtgever: opdrachtgevers.filter(og => og.id === id)[0],
        opdrachtgever_id: id,
        user_id: user.id,
      });
    }
    setUser(prevState => ({
      ...prevState,
      opdrachtgevers: newOpdrachtgevers,
    }));
  };

  if (!id || !(id === 'new' || user.id)) {
    return <></>;
  }

  return (
    <div className="users-page">
      <h1 className="users-header">{id != 'new' && user ? user.username : 'Nieuw'}</h1>
      <div className="chair-item">
        <div className="chair-item-header">
          <FaSave className="update-icon" onClick={() => addUser()} title="Opslaan" />
          {userData && <FaTrash className="update-icon" onClick={() => deleteUser()} title="Verwijder" />}
        </div>
        <div className="property">
          <label>Naam:</label>
          <input type="text" name="username" value={user.username} onChange={updateUser}></input>
        </div>
        <div className="property">
          <label>Email:</label>
          <input type="text" name="email" value={user.email} onChange={updateUser}></input>
        </div>
        <div className="roles">
          <h3>Roles</h3>
          {roles.map(name => (
            <div key={name} className={'role-item ' + (user.roles.map(role => role.name).includes(name) ? 'selected' : '')} onClick={() => toggleRole(name)}>
              <span>{name}</span>
            </div>
          ))}
        </div>
        <div className="roles">
          <h3>Opdrachtgevers</h3>
          {opdrachtgevers.map(og => (
            <div
              key={og.id}
              className={'role-item ' + (user.opdrachtgevers.map(og => og.opdrachtgever_id).includes(og.id || '') ? 'selected' : '')}
              onClick={() => toggleOpdrachtgever(og.id || '')}>
              <span>{og.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserPage;
